export default __webpack_public_path__ + "static/guepes-17ec151c9692e642a40020bb6bcd37e5.jpg";